import { render, staticRenderFns } from "./ForwardForConfirmationModal.vue?vue&type=template&id=6357ebad&scoped=true"
import script from "./ForwardForConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ForwardForConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./ForwardForConfirmationModal.vue?vue&type=style&index=0&id=6357ebad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357ebad",
  null
  
)

export default component.exports